import { useEffect, useRef } from 'react'
import Button from '../shared/Button'
import Title from '../shared/Title'
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver'
import { useNavigate } from 'react-router-dom'

const Hero = () => {
  const [heroRef, isVisible] = useIntersectionObserver()
  const parallaxRef = useRef(null)
  const particlesRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!parallaxRef.current) return
      
      const { clientX, clientY } = e
      const { innerWidth, innerHeight } = window
      
      const moveX = (clientX - innerWidth / 2) / innerWidth * 20
      const moveY = (clientY - innerHeight / 2) / innerHeight * 20
      
      parallaxRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`
    }

    // Particle animation
    const createParticle = () => {
      if (!particlesRef.current) return
      
      const particle = document.createElement('div')
      particle.className = 'hero__particle'
      
      // Random position and size
      const size = Math.random() * 10 + 5
      particle.style.width = `${size}px`
      particle.style.height = `${size}px`
      particle.style.left = `${Math.random() * 100}%`
      
      particlesRef.current.appendChild(particle)
      
      // Remove particle after animation
      setTimeout(() => particle.remove(), 10000)
    }

    const particleInterval = setInterval(createParticle, 1000)
    window.addEventListener('mousemove', handleMouseMove)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      clearInterval(particleInterval)
    }
  }, [])

  const handleRegister = () => {
    navigate('/register')
  }

  return (
    <section id="hero" className="hero" ref={heroRef}>
      <div className="hero__pattern"></div>
      <div className="hero__overlay"></div>
      <div className="hero__symbols">
        <span className="symbol" role="img" aria-label="graduation">🎓</span>
        <span className="symbol" role="img" aria-label="books">📚</span>
        <span className="symbol" role="img" aria-label="growth">🌱</span>
        <span className="symbol" role="img" aria-label="career">💼</span>
        <span className="symbol" role="img" aria-label="networking">🤝</span>
        <span className="symbol" role="img" aria-label="goals">🎯</span>
      </div>
      
      <div className={`container hero__content ${isVisible ? 'animate fade-in' : ''}`}>
        <div className="hero__parallax" ref={parallaxRef}>
          <Title 
            tagline="A family for life"
            heading="Welcome to RAYS"
            subheading="The Rajagiri Public School Alumni Network"
            animate={isVisible}
          />
          
          <p className={`hero__text animate slide-up delay-2 ${isVisible ? 'visible' : ''}`}>
            RAYS is your gateway to reconnecting with old friends, forging new bonds, 
            and celebrating the lifelong spirit of Rajagiri.
          </p>

          <div className={`hero__cta animate slide-up delay-3 ${isVisible ? 'visible' : ''}`}>
            <Button 
              variant="primary" 
              className="glow-effect"
              onClick={handleRegister}
            >
              2025 Batch Registration
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero 